import { render, staticRenderFns } from "./OrdenCarouselComponent.vue?vue&type=template&id=3b8b81e4"
import script from "./OrdenCarouselComponent.vue?vue&type=script&lang=js"
export * from "./OrdenCarouselComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports